/* eslint-disable react/prop-types */
import {
  forwardRef,
  memo,
  useEffect,
  useState,
  useCallback,
  useImperativeHandle,
} from 'react';

import Button from 'components/Button';
import Typography from 'components/Typography';

function ExamPdf(
  { answer, onAnswerChange },
  ref // eslint-disable-line no-unused-vars
) {
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [progress, setProgress] = useState(false);

  const selectFile = (event) => {
    setSelectedFiles(event.target.files);
  };

  useImperativeHandle(
    ref,
    () => ({
      componentWillUnmount: () => {
        setSelectedFiles(undefined);
        setProgress(false);
      },
    }),
    []
  );

  useEffect(() => {
    setProgress(false);
  }, [answer]);

  // Menyimpan dan upload jawaban .
  const handleSaveClick = useCallback(() => {
    // eslint-disable-next-line no-underscore-dangle
    const _currentFile = selectedFiles[0];
    if (!setSelectedFiles) return;
    setProgress(true);
    onAnswerChange(_currentFile);
  }, [onAnswerChange, selectedFiles]);

  const handleResetAnswer = useCallback(() => {
    if (!setSelectedFiles) return;
    setSelectedFiles(undefined);
    onAnswerChange(' ');
  }, [onAnswerChange]);

  const statusJwb = useCallback(() => {
    if (answer !== ' ') {
      return false;
    }
    if (!selectedFiles || progress) {
      return true;
    }
    return false;
  }, [answer, progress, selectedFiles]);

  return (
    <>
      <div className="flex justify-center gap-4 mt-4">
        <input type="file" accept="application/pdf" onChange={selectFile} />
        <Button
          type="button"
          size="sm"
          color="primary"
          loading={progress}
          disabled={!selectedFiles || progress}
          onClick={handleSaveClick}
        >
          Simpan
        </Button>
        <Button
          type="button"
          size="sm"
          color="danger"
          disabled={statusJwb()}
          onClick={handleResetAnswer}
        >
          Hapus
        </Button>
      </div>

      <Typography variant="subtitle1" className="font-medium mt-8">
        Jawaban
      </Typography>
      {answer !== ' ' ? (
        <div className="flex">
          <span className="mt-5 px-5 py-3 bg-green-500 rounded-md">
            {answer}
          </span>
        </div>
      ) : (
        <div className="flex">
          <span className="mt-5 px-5 py-3">
            Jawaban tidak ada. Upload File PDF terlebih dahulu.
          </span>
        </div>
      )}
    </>
  );
}

ExamPdf = forwardRef(ExamPdf);

export default memo(ExamPdf);
